module.exports = __webpack_public_path__ + "img/buildyourown_v3.26d9fa4.svg";